module.exports = __webpack_public_path__ + "static/media/icons-yc-ruler-select.0290b4bf.svg";